import { AppointmentParticipantResponse } from "@9amhealth/openapi";
import Scheduler from "molecule/scheduler/Scheduler";
import { FC } from "react";
import Avatar from "../Avatar/Avatar";

const ReuseProviderScheduler: FC<{
  previousProvider: AppointmentParticipantResponse | null | undefined;
  requestProviders: string[] | false | undefined;
  onDismiss: () => void;
}> = ({ previousProvider, requestProviders, onDismiss }) => {
  if (!previousProvider || !requestProviders) {
    return null;
  }

  return (
    <Scheduler
      view="reuse-provider"
      avatar={(id) => <Avatar id={id} />}
      id={previousProvider.userId}
      name={previousProvider.displayName || ""}
      onClose={onDismiss}
    />
  );
};

export default ReuseProviderScheduler;
